import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AlertsComponent } from './alerts.component';
import { FuseAlertModule } from '@fuse/components/alert';

@NgModule({
  imports: [CommonModule, FuseAlertModule],
  declarations: [AlertsComponent],
  exports: [AlertsComponent],
})
export class AlertsModule {}
